import React from 'react'
export const Spacer: React.FC = () => {
  return <div style={{ height: 20, width: 20 }} />
}
